module.exports = new __parcel__URL__("blueBar.ae629b00.svg").toString();